// import { DataGrid } from "@mui/x-data-grid";
// import React, { useEffect, useState } from "react";
// import { TextField, Modal, Box, Typography, Card, Grid } from "@mui/material";
// import axios from "axios";

// const WalletDetails = () => {
//   const [searchText, setSearchText] = useState("");
//   const [data, setData] = useState([]);
//   const [totalPrice, setTotalPrice] = useState(null);
//   const [transaction, setTransaction] = useState(null);
//   const [openModal, setOpenModal] = useState(false);
//   const [selectedOrderDetails, setSelectedOrderDetails] = useState(null);

//   const handleSearchTextChange = (event) => {
//     setSearchText(event.target.value);
//   };

//   const paymentHandler = async () => {
//     try {
//       const res = await axios.get(
//         "https://api.medstown.com/pay/p1/getpayments"
//       );
//       setTransaction(res?.data?.total_transaction);
//       setTotalPrice(res.data.total_amount);
//       setData(res?.data?.payment);
//     } catch (error) {
//       console.log(error);
//     }
//   };

//   const transactionDetails = async (orderId) => {
//     setOpenModal(true);
//     console.log(orderId, "id");
//     try {
//       const finalOrderRes = await axios.get(
//         `https://api.medstown.com/customer/findorderid/${orderId}`
//       );
//       // console.log(finalOrderRes?.data, "sssssssssssss");
//       setSelectedOrderDetails({ finalOrderDetails: finalOrderRes.data });
//       setOpenModal(true);
//     } catch (error) {
//       console.log(error);
//     }
//   };

//   useEffect(() => {
//     paymentHandler();
//   }, []);

//   const filteredRows = data.filter((row) =>
//     Object.values(row).some(
//       (value) =>
//         value &&
//         value.toString().toLowerCase().includes(searchText.toLowerCase())
//     )
//   );

//   const tableColumns = [
//     { field: "orderId", headerName: "Order ID", width: 150 },
//     { field: "customerId", headerName: "Customer ID", width: 150 },
//     {
//       field: "orderTotal",
//       headerName: "Order Total",
//       width: 150,
//       renderCell: (params) => params.value / 100,
//     },
//     { field: "orderNature", headerName: "Order Nature", width: 150 },
//     { field: "paymentId", headerName: "Payment ID", width: 150 },
//     { field: "mobileNumber", headerName: "Mobile Number", width: 150 },
//     { field: "paymentStatus", headerName: "Payment Status", width: 150 },
//     {
//       field: "createdAt",
//       headerName: "Order Date",
//       width: 180,
//       renderCell: (params) => new Date(params.value).toLocaleString(),
//     },
//   ];

//   // console.log(selectedOrderDetails?.finalOrderDetails);

//   return (
//     <div style={{ padding: "20px" }}>
//       <Grid container spacing={3}>
//         <Grid item xs={12} md={6}>
//           <Card variant="outlined" style={{ padding: "16px" }}>
//             <Typography variant="h6">Total Earnings</Typography>
//             <Typography variant="h4">₹{totalPrice}</Typography>
//           </Card>
//         </Grid>
//         <Grid item xs={12} md={6}>
//           <Card variant="outlined" style={{ padding: "16px" }}>
//             <Typography variant="h6">Total Transactions</Typography>
//             <Typography variant="h4">{transaction}</Typography>
//           </Card>
//         </Grid>
//       </Grid>

//       <div style={{ marginTop: "20px" }}>
//         <TextField
//           label="Search"
//           variant="outlined"
//           fullWidth
//           value={searchText}
//           onChange={handleSearchTextChange}
//         />

//         <div style={{ marginTop: "20px", height: "550px" }}>
//           <DataGrid
//             rows={filteredRows}
//             columns={tableColumns}
//             pageSize={5}
//             rowsPerPageOptions={[5]}
//             disableSelectionOnClick
//             sx={{ width: "100%" }}
//             getRowId={(row) => row._id}
//             onRowClick={(params) => {
//               transactionDetails(params.row.orderId);
//             }}
//           />
//         </div>
//       </div>

//       <Modal
//         open={openModal}
//         onClose={() => setOpenModal(false)}
//         aria-labelledby="order-details-modal"
//         aria-describedby="order-details-description"
//       >
//         <Box
//           sx={{
//             position: "absolute",
//             top: "50%",
//             left: "50%",
//             transform: "translate(-50%, -50%)",
//             width: 400,
//             bgcolor: "background.paper",
//             border: "2px solid #000",
//             boxShadow: 24,
//             p: 4,
//           }}
//         >
//           <Typography id="order-details-modal" variant="h6"></Typography>
//           {selectedOrderDetails ? (
//             <div>
//               <Typography>
//                 <strong>Order ID:</strong>{" "}
//                 {selectedOrderDetails?.finalOrderDetails?.orderId}
//               </Typography>
//               <Typography>
//                 <strong>Total Price:</strong> ₹
//                 {selectedOrderDetails?.finalOrderDetails?.totalPrice}
//               </Typography>
//               <hr />
//               <Typography>
//                 <strong>Items:</strong>{" "}
//                 {selectedOrderDetails.finalOrderDetails?.items?.join(", ")}
//               </Typography>
//               <Typography>
//                 <strong>Customer Name:</strong>
//                 {selectedOrderDetails?.finalOrderDetails?.customerName}
//               </Typography>
//               {/* <Typography>
//                 <strong>Total Amount:</strong> ₹
//                 {selectedOrderDetails?.finalOrderDetails?.customerName}
//               </Typography> */}
//               <Typography>
//                 <strong>Pharmacy Name:</strong>{" "}
//                 {selectedOrderDetails.finalOrderDetails.pharmacyName}
//               </Typography>
//               <Typography>
//                 <strong>Delivery Partner Name:</strong>{" "}
//                 {selectedOrderDetails?.finalOrderDetails?.deliveryBoyName}
//               </Typography>

//               <Typography>
//                 <strong>Delivery Price:</strong> ₹{" "}
//                 {selectedOrderDetails.finalOrderDetails.deliveryPrice}
//               </Typography>
//               <Typography>
//                 <strong>Payment Type:</strong>{" "}
//                 {selectedOrderDetails.finalOrderDetails.paymentType}
//               </Typography>
//             </div>
//           ) : (
//             <Typography>No order details found.</Typography>
//           )}
//         </Box>
//       </Modal>
//     </div>
//   );
// };

// export default WalletDetails;


import React, { useEffect, useState } from "react";
import {
  TextField,
  Modal,
  Box,
  Typography,
  Card,
  Grid,
  InputAdornment,
  IconButton,
  useTheme,
  alpha,
  LinearProgress,
  Skeleton,
  Alert,
  Fade,
  Avatar,
  Stack,
  Chip,
  Container,
  Paper,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import {
  MdSearch,
  MdClear,
  MdAccountBalanceWallet,
  MdTrendingUp,
  MdReceipt,
  MdPerson,
  MdPhone,
  MdStore,
  MdLocalShipping,
  MdPayment,
  MdClose,
  MdError,
  MdAttachMoney,
} from "react-icons/md";
import axios from "axios";
import dayjs from "dayjs";

const WalletDetails = () => {
  const theme = useTheme();
  const [searchText, setSearchText] = useState("");
  const [data, setData] = useState([]);
  const [totalPrice, setTotalPrice] = useState(null);
  const [transaction, setTransaction] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [selectedOrderDetails, setSelectedOrderDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [searchLoading, setSearchLoading] = useState(false);

  const handleSearchTextChange = (event) => {
    setSearchText(event.target.value);
    setSearchLoading(true);
    setTimeout(() => setSearchLoading(false), 200);
  };

  const clearSearch = () => {
    setSearchText("");
  };

  const paymentHandler = async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await axios.get("https://api.medstown.com/pay/p1/getpayments");
      setTransaction(res?.data?.total_transaction);
      setTotalPrice(res.data.total_amount);
      setData(res?.data?.payment || []);
    } catch (error) {
      console.error(error);
      setError("Failed to fetch wallet data. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const transactionDetails = async (orderId) => {
    setOpenModal(true);
    try {
      const finalOrderRes = await axios.get(
        `https://api.medstown.com/customer/findorderid/${orderId}`
      );
      setSelectedOrderDetails({ finalOrderDetails: finalOrderRes.data });
    } catch (error) {
      console.error(error);
      setError("Failed to fetch order details.");
    }
  };

  useEffect(() => {
    paymentHandler();
  }, []);

  const filteredRows = data.filter((row) =>
    Object.values(row).some(
      (value) =>
        value &&
        value.toString().toLowerCase().includes(searchText.toLowerCase())
    )
  );

  const getPaymentStatusConfig = (status) => {
    const configs = {
      "success": {
        color: "#4caf50",
        bgColor: alpha("#4caf50", 0.1),
      },
      "completed": {
        color: "#4caf50",
        bgColor: alpha("#4caf50", 0.1),
      },
      "pending": {
        color: "#ff9800",
        bgColor: alpha("#ff9800", 0.1),
      },
      "failed": {
        color: "#f44336",
        bgColor: alpha("#f44336", 0.1),
      }
    };
    return configs[status?.toLowerCase()] || {
      color: "#757575",
      bgColor: alpha("#757575", 0.1),
    };
  };

  const tableColumns = [
    {
      field: "orderId",
      headerName: "Order ID",
      flex:1,
      renderCell: (params) => (
        <Box component="span" sx={{ 
          color: theme.palette.primary.main,
          fontFamily: 'monospace',
          backgroundColor: alpha(theme.palette.primary.main, 0.08),
          px: 0.6,
          py: 0.3,
          borderRadius: 0.8,
          fontSize: '0.85rem',
          fontWeight: 600
        }}>
          {params.value}
        </Box>
      ),
    },
    {
      field: "customerId",
      headerName: "Customer ID",
     flex:1,
      renderCell: (params) => (
        <Typography variant="caption" sx={{ fontFamily: 'monospace', fontSize: '0.85rem' }}>
          {params.value}
        </Typography>
      ),
    },
    {
      field: "orderTotal",
      headerName: "Total",
 flex:1,
      renderCell: (params) => (
        <Typography variant="caption" fontWeight={600} color="success.main">
          ₹{(params.value / 100).toLocaleString()}
        </Typography>
      ),
    },
    {
      field: "orderNature",
      headerName: "Nature",
 flex:1,
      renderCell: (params) => (
        <Chip 
          label={params.value}
          size="small"
          variant="outlined"
          sx={{ 
            fontSize: '0.65rem', 
            height: 18,
            borderColor: alpha(theme.palette.secondary.main, 0.4),
            color: theme.palette.secondary.main,
          }}
        />
      ),
    },
    {
      field: "paymentId",
      headerName: "Payment ID",
  flex:1,
      renderCell: (params) => (
        <Typography variant="caption" sx={{ fontFamily: 'monospace', fontSize: '0.65rem' }}>
          {params.value}
        </Typography>
      ),
    },
    {
      field: "mobileNumber",
      headerName: "Mobile",
     flex:1,
      renderCell: (params) => (
        <Stack direction="row" alignItems="center" spacing={0.5}>
          <MdPhone size={10} color={theme.palette.text.secondary} />
          <Typography variant="caption" sx={{ fontFamily: 'monospace', fontSize: '0.85rem' }}>
            {params.value}
          </Typography>
        </Stack>
      ),
    },
    {
      field: "paymentStatus",
      headerName: "Status",
   flex:1,
      renderCell: (params) => {
        const statusConfig = getPaymentStatusConfig(params.value);
        return (
          <Chip 
            label={params.value}
            size="small"
            sx={{ 
              fontSize: '0.65rem',
              height: 18,
              backgroundColor: statusConfig.bgColor,
              color: statusConfig.color,
              border: `1px solid ${alpha(statusConfig.color, 0.3)}`,
              fontWeight: 600
            }}
          />
        );
      },
    },
    {
      field: "createdAt",
      headerName: "Date",
  flex:1,
      renderCell: (params) => (
        <Box>
          <Typography variant="caption" fontWeight={500} sx={{ fontSize: '0.85rem' }}>
            {dayjs(params.value).format("MMM DD")}
          </Typography>
          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', fontSize: '0.65rem' }}>
            {dayjs(params.value).format("hh:mm A")}
          </Typography>
        </Box>
      ),
    },
  ];

  if (loading) {
    return (
      <Container maxWidth="xl" sx={{ py: 1 }}>
        <Grid container spacing={1.5}>
          <Grid item xs={12} md={6}>
            <Skeleton variant="rectangular" height={80} sx={{ borderRadius: 2 }} />
          </Grid>
          <Grid item xs={12} md={6}>
            <Skeleton variant="rectangular" height={80} sx={{ borderRadius: 2 }} />
          </Grid>
          <Grid item xs={12}>
            <Skeleton variant="rectangular" height={300} sx={{ borderRadius: 2 }} />
          </Grid>
        </Grid>
      </Container>
    );
  }

  return (
    <Container maxWidth="xl" sx={{ py: 1 ,mt:5}}>
      {/* Compact Header */}
      <Box sx={{ mb: 2 }}>
        <Typography variant="h6" fontWeight={700} color="primary.main" sx={{ mb: 0.2 }}>
          Wallet Details
        </Typography>
        <Typography variant="caption" color="text.secondary">
          Monitor transactions and earnings
        </Typography>
      </Box>

      {/* Error Alert */}
      {error && (
        <Alert 
          severity="error" 
          sx={{ mb: 1.5, borderRadius: 1.5, p: 1 }}
          icon={<MdError size={16} />}
          action={
            <IconButton size="small" onClick={() => setError(null)}>
              <MdClear size={14} />
            </IconButton>
          }
        >
          <Typography variant="caption">{error}</Typography>
        </Alert>
      )}

      {/* Compact Stats Cards */}
      <Grid container spacing={1.5} sx={{ mb: 2 }}>
        <Grid item xs={12} md={6}>
          <Card elevation={0} sx={{ 
            borderRadius: 2, 
            border: `1px solid ${alpha(theme.palette.divider, 0.08)}`,
            background: `linear-gradient(135deg, ${alpha(theme.palette.success.main, 0.1)}, ${alpha(theme.palette.success.main, 0.05)})`,
            transition: 'all 0.2s ease',
            '&:hover': {
              transform: 'translateY(-2px)',
              boxShadow: `0 8px 16px ${alpha(theme.palette.success.main, 0.15)}`
            }
          }}>
            <Box sx={{ p: 1.5 }}>
              <Stack direction="row" alignItems="center" spacing={1.5}>
                <Avatar sx={{ 
                  backgroundColor: theme.palette.success.main,
                  color: 'white',
                  width: 32,
                  height: 32
                }}>
                  {/* <MdAttachMoney size={18} /> */}
                </Avatar>
                <Box sx={{ flexGrow: 1 }}>
                  <Typography variant="caption" color="success.main" fontWeight={600} sx={{ display: 'block' }}>
                    Total Earnings
                  </Typography>
                  <Typography variant="h6" fontWeight={800} color="success.main">
                    ₹{totalPrice?.toLocaleString() || 0}
                  </Typography>
                </Box>
              </Stack>
            </Box>
          </Card>
        </Grid>

        <Grid item xs={12} md={6}>
          <Card elevation={0} sx={{ 
            borderRadius: 2, 
            border: `1px solid ${alpha(theme.palette.divider, 0.08)}`,
            background: `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.1)}, ${alpha(theme.palette.primary.main, 0.05)})`,
            transition: 'all 0.2s ease',
            '&:hover': {
              transform: 'translateY(-2px)',
              boxShadow: `0 8px 16px ${alpha(theme.palette.primary.main, 0.15)}`
            }
          }}>
            <Box sx={{ p: 1.5 }}>
              <Stack direction="row" alignItems="center" spacing={1.5}>
                <Avatar sx={{ 
                  backgroundColor: theme.palette.primary.main,
                  color: 'white',
                  width: 32,
                  height: 32
                }}>
                  <MdTrendingUp size={18} />
                </Avatar>
                <Box sx={{ flexGrow: 1 }}>
                  <Typography variant="caption" color="primary.main" fontWeight={600} sx={{ display: 'block' }}>
                    Total Transactions
                  </Typography>
                  <Typography variant="h6" fontWeight={800} color="primary.main">
                    {transaction?.toLocaleString() || 0}
                  </Typography>
                </Box>
              </Stack>
            </Box>
          </Card>
        </Grid>
      </Grid>

      {/* Compact Search and Data Grid */}
      <Card elevation={0} sx={{ 
        borderRadius: 2, 
        border: `1px solid ${alpha(theme.palette.divider, 0.08)}`,
        overflow: 'hidden'
      }}>
        {/* Compact Search Header */}
        <Box sx={{ p: 1.5, pb: 1 }}>
          <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={2}>
            <Box>
              <Typography variant="body2" fontWeight={600} sx={{ mb: 0.2 }}>
                Transaction History
              </Typography>
              {/* <Typography variant="caption" color="text.secondary">
                {filteredRows.length} transactions
              </Typography> */}
            </Box>

            {/* Compact Search */}
            <TextField
              variant="outlined"
              size="small"
              placeholder="Search transactions..."
              value={searchText}
              onChange={handleSearchTextChange}
              sx={{
                width: 280,
                '& .MuiOutlinedInput-root': {
                  backgroundColor: alpha(theme.palette.background.paper, 0.8),
                  borderRadius: 2,
                  fontSize: '0.8rem',
                  '& fieldset': {
                    borderColor: alpha(theme.palette.primary.main, 0.2),
                  },
                  '&:hover fieldset': {
                    borderColor: alpha(theme.palette.primary.main, 0.4),
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: theme.palette.primary.main,
                  },
                },
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    {searchLoading ? (
                      <LinearProgress sx={{ width: 16, height: 2, borderRadius: 1 }} />
                    ) : (
                      <MdSearch size={16} color={theme.palette.primary.main} />
                    )}
                  </InputAdornment>
                ),
                endAdornment: searchText && (
                  <InputAdornment position="end">
                    <IconButton
                      size="small"
                      onClick={clearSearch}
                      sx={{ 
                        color: theme.palette.text.secondary,
                        width: 20,
                        height: 20
                      }}
                    >
                      <MdClear size={14} />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Stack>
        </Box>

        {/* Compact Data Grid */}
        <Box sx={{ height: 500, px: 1.5, pb: 1.5 }}>
          <DataGrid
            rows={filteredRows}
            columns={tableColumns}
            pageSize={8}
            rowsPerPageOptions={[5, 8, 15]}
            disableSelectionOnClick
            getRowId={(row) => row._id}
            onRowClick={(params) => transactionDetails(params.row.orderId)}
            sx={{
              border: 'none',
              '& .MuiDataGrid-main': {
                borderRadius: 1.5,
              },
              '& .MuiDataGrid-columnHeaders': {
                backgroundColor: alpha(theme.palette.primary.main, 0.06),
                borderRadius: '6px 6px 0 0',
                minHeight: '36px !important',
                '& .MuiDataGrid-columnHeader': {
                  fontWeight: 700,
                  color: theme.palette.primary.main,
                  fontSize: '0.7rem',
                  textTransform: 'uppercase',
                  letterSpacing: '0.3px',
                },
              },
              '& .MuiDataGrid-row': {
                cursor: 'pointer',
                minHeight: '40px !important',
                borderBottom: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
                '&:hover': {
                  backgroundColor: alpha(theme.palette.primary.main, 0.03),
                  transform: 'translateY(-1px)',
                },
                transition: 'all 0.2s ease',
              },
              '& .MuiDataGrid-cell': {
                borderBottom: 'none',
                fontSize: '0.75rem',
                padding: '6px 8px',
              },
            }}
          />
        </Box>
      </Card>

      {/* Compact Modal */}
      <Modal
        open={openModal}
        onClose={() => setOpenModal(false)}
        closeAfterTransition
      >
        <Fade in={openModal}>
          <Box sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: '90%', sm: 480 },
            maxHeight: '85vh',
            overflow: 'auto',
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: `0 16px 32px ${alpha(theme.palette.common.black, 0.15)}`,
            border: `1px solid ${alpha(theme.palette.divider, 0.1)}`
          }}>
            {/* Compact Modal Header */}
            <Box sx={{ 
              p: 1.5, 
              background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
              color: 'white'
            }}>
              <Stack direction="row" alignItems="center" justifyContent="space-between">
                <Stack direction="row" alignItems="center" spacing={1.5}>
                  <Avatar sx={{ 
                    backgroundColor: alpha(theme.palette.common.white, 0.2),
                    color: 'white',
                    width: 24,
                    height: 24
                  }}>
                    <MdReceipt size={14} />
                  </Avatar>
                  <Box>
                    <Typography variant="body1" fontWeight={700}>
                      Order Details
                    </Typography>
                    <Typography variant="caption" sx={{ opacity: 0.9 }}>
                      Transaction information
                    </Typography>
                  </Box>
                </Stack>
                <IconButton 
                  onClick={() => setOpenModal(false)}
                  size="small"
                  sx={{ 
                    color: 'white',
                    backgroundColor: alpha(theme.palette.common.white, 0.1),
                    width: 24,
                    height: 24
                  }}
                >
                  <MdClose size={16} />
                </IconButton>
              </Stack>
            </Box>

            {/* Compact Modal Content */}
            <Box sx={{ p: 1.5 }}>
              {selectedOrderDetails ? (
                <Stack spacing={1.5}>
                  {/* Order Info Section */}
                  <Paper sx={{ p: 1.5, backgroundColor: alpha(theme.palette.primary.main, 0.05), borderRadius: 1.5 }}>
                    <Typography variant="caption" fontWeight={600} color="primary.main" sx={{ mb: 1, display: 'block' }}>
                      Order Information
                    </Typography>
                    <Grid container spacing={1.5}>
                      <Grid item xs={12} sm={6}>
                        <Stack spacing={0.5}>
                          <Typography variant="caption" color="text.secondary" fontWeight={500} sx={{ fontSize: '0.6rem' }}>
                            Order ID
                          </Typography>
                          <Typography variant="caption" fontWeight={600} sx={{ fontFamily: 'monospace' }}>
                            #{selectedOrderDetails?.finalOrderDetails?.orderId}
                          </Typography>
                        </Stack>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Stack spacing={0.5}>
                          <Typography variant="caption" color="text.secondary" fontWeight={500} sx={{ fontSize: '0.6rem' }}>
                            Total Price
                          </Typography>
                          <Typography variant="body2" fontWeight={700} color="success.main">
                            ₹{selectedOrderDetails?.finalOrderDetails?.totalPrice?.toLocaleString()}
                          </Typography>
                        </Stack>
                      </Grid>
                    </Grid>
                  </Paper>

                  {/* Customer Section */}
                  <Paper sx={{ p: 1.5, backgroundColor: alpha(theme.palette.secondary.main, 0.05), borderRadius: 1.5 }}>
                    <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
                      <Avatar sx={{ 
                        backgroundColor: alpha(theme.palette.secondary.main, 0.1),
                        color: theme.palette.secondary.main,
                        width: 20,
                        height: 20
                      }}>
                        <MdPerson size={12} />
                      </Avatar>
                      <Typography variant="caption" fontWeight={600} color="secondary.main">
                        Customer Details
                      </Typography>
                    </Stack>
                    <Typography variant="caption" fontWeight={500}>
                      {selectedOrderDetails?.finalOrderDetails?.customerName}
                    </Typography>
                  </Paper>

                  {/* Service Providers */}
                  <Grid container spacing={1}>
                    <Grid item xs={12} sm={6}>
                      <Paper sx={{ p: 1, backgroundColor: alpha(theme.palette.info.main, 0.05), borderRadius: 1 }}>
                        <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 0.8 }}>
                          <Avatar sx={{ 
                            backgroundColor: alpha(theme.palette.info.main, 0.1),
                            color: theme.palette.info.main,
                            width: 18,
                            height: 18
                          }}>
                            <MdStore size={10} />
                          </Avatar>
                          <Typography variant="caption" fontWeight={600} color="info.main" sx={{ fontSize: '0.65rem' }}>
                            Pharmacy
                          </Typography>
                        </Stack>
                        <Typography variant="caption" sx={{ fontSize: '0.6rem' }}>
                          {selectedOrderDetails?.finalOrderDetails?.pharmacyName || 'Not assigned'}
                        </Typography>
                      </Paper>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <Paper sx={{ p: 1, backgroundColor: alpha(theme.palette.warning.main, 0.05), borderRadius: 1 }}>
                        <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 0.8 }}>
                          <Avatar sx={{ 
                            backgroundColor: alpha(theme.palette.warning.main, 0.1),
                            color: theme.palette.warning.main,
                            width: 18,
                            height: 18
                          }}>
                            <MdLocalShipping size={10} />
                          </Avatar>
                          <Typography variant="caption" fontWeight={600} color="warning.main" sx={{ fontSize: '0.65rem' }}>
                            Delivery Partner
                          </Typography>
                        </Stack>
                        <Typography variant="caption" sx={{ fontSize: '0.6rem' }}>
                          {selectedOrderDetails?.finalOrderDetails?.deliveryBoyName || 'Not assigned'}
                        </Typography>
                      </Paper>
                    </Grid>
                  </Grid>

                  {/* Payment Details */}
                  <Paper sx={{ p: 1.5, backgroundColor: alpha(theme.palette.success.main, 0.05), borderRadius: 1.5 }}>
                    <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
                      <Avatar sx={{ 
                        backgroundColor: alpha(theme.palette.success.main, 0.1),
                        color: theme.palette.success.main,
                        width: 20,
                        height: 20
                      }}>
                        <MdPayment size={12} />
                      </Avatar>
                      <Typography variant="caption" fontWeight={600} color="success.main">
                        Payment Information
                      </Typography>
                    </Stack>
                    <Grid container spacing={1.5}>
                      <Grid item xs={12} sm={6}>
                        <Stack spacing={0.5}>
                          <Typography variant="caption" color="text.secondary" fontWeight={500} sx={{ fontSize: '0.6rem' }}>
                            Payment Type
                          </Typography>
                          <Chip 
                            label={selectedOrderDetails?.finalOrderDetails?.paymentType}
                            size="small"
                            sx={{ 
                              backgroundColor: alpha(theme.palette.info.main, 0.1),
                              color: theme.palette.info.main,
                              alignSelf: 'flex-start',
                              height: 18,
                              fontSize: '0.6rem'
                            }}
                          />
                        </Stack>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Stack spacing={0.5}>
                          <Typography variant="caption" color="text.secondary" fontWeight={500} sx={{ fontSize: '0.6rem' }}>
                            Delivery Price
                          </Typography>
                          <Typography variant="caption" fontWeight={600} color="success.main">
                            ₹{selectedOrderDetails?.finalOrderDetails?.deliveryPrice}
                          </Typography>
                        </Stack>
                      </Grid>
                    </Grid>
                  </Paper>

                  {/* Items */}
                  {selectedOrderDetails?.finalOrderDetails?.items && (
                    <Paper sx={{ p: 1.5, backgroundColor: alpha(theme.palette.grey[500], 0.05), borderRadius: 1.5 }}>
                      <Typography variant="caption" fontWeight={600} sx={{ mb: 1, display: 'block' }}>
                        Order Items
                      </Typography>
                      <Typography variant="caption" sx={{ fontSize: '0.6rem' }}>
                        {selectedOrderDetails.finalOrderDetails.items.join(", ")}
                      </Typography>
                    </Paper>
                  )}
                </Stack>
              ) : (
                <Box textAlign="center" sx={{ py: 2 }}>
                  <Avatar sx={{ 
                    width: 40,
                    height: 40,
                    backgroundColor: alpha(theme.palette.error.main, 0.1),
                    color: theme.palette.error.main,
                    mx: 'auto',
                    mb: 1
                  }}>
                    <MdError size={20} />
                  </Avatar>
                  <Typography variant="caption" color="text.primary" fontWeight={600}>
                    No order details found
                  </Typography>
                </Box>
              )}
            </Box>
          </Box>
        </Fade>
      </Modal>
    </Container>
  );
};

export default WalletDetails;
